import React from 'react';
import { Link } from 'react-router-dom';

// "By continuing you agree to our Terms of Service and Privacy Policy" — the line under the sign-in and
// sign-up forms. `action` completes "By ____ you agree".
const LegalLinks = ({ action = 'continuing', style }) => (
  <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.6, margin: 0, ...style }}>
    By {action} you agree to our <Link to="/terms" className="auth-link">Terms of Service</Link> and{' '}
    <Link to="/privacy" className="auth-link">Privacy Policy</Link>.
  </p>
);

export default LegalLinks;
